import get from 'lodash/get';
import find from 'lodash/find';
import { createSelector } from 'reselect';
import { APP_LOCALE_LANGUAGES_MAP } from 'localeConstants';
import * as constants from './constants';
/**
 * Input selectors
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
//----------------------------------------------------------------------------------------------------------------------
/**
 * Selects if client re-renders app after cold start
 */ export const isClientInitialized = (state)=>mainSelector(state).isClientInitialized;
/**
 * Selects current region name
 */ export const regionName = (state)=>mainSelector(state).regionName;
/**
 * Selects original region name
 */ export const originalRegionName = (state)=>mainSelector(state).originalRegionName;
/**
 * Regions dictionary
 */ export const regions = (state)=>mainSelector(state).regions;
/**
 * Selects current region
 */ export const region = createSelector(regionName, regions, (regionNameState, regionsState)=>find(regionsState, {
        name: regionNameState
    }));
/**
 * Selects country context
 */ export const country = (state)=>mainSelector(state).country;
/**
 * Selects html direction
 */ export const direction = (state)=>mainSelector(state).direction;
/**
 * Selects locale setting
 */ export const locale = (state)=>mainSelector(state).locale;
/**
 * Selects language code setting
 */ export const langCode = (state)=>APP_LOCALE_LANGUAGES_MAP[locale(state)] || locale(state);
/**
 * Selects translations for the language code
 */ export const translations = (state)=>mainSelector(state).translations;
/**
 * Countries dictionary
 */ export const countries = (state)=>mainSelector(state).countries;
/**
 * Selects country context by countryId
 */ export const countryById = (countryId)=>createSelector(countries, (itemList)=>itemList.find((item)=>item.countryId === countryId));
/**
 * Country settings
 */ export const countrySettings = (state)=>mainSelector(state).countrySettings;
/**
 * Devices list
 */ export const devices = (state)=>mainSelector(state).devices;
/**
 * Devices case types list
 */ export const caseTypes = (state)=>mainSelector(state).caseTypes;
/**
 * Languages dictionary
 */ export const languages = (state)=>mainSelector(state).languages;
/**
 * Localization resources
 */ export const localizationResources = (state)=>mainSelector(state).localizationResources;
/**
 * Alerts selector
 */ export const alerts = (state)=>mainSelector(state).alerts;
/**
 * System alerts selector
 */ export const systemAlerts = (state)=>mainSelector(state).systemAlerts;
/**
 * System alerts settings selector
 */ export const systemAlertsSettings = (state)=>mainSelector(state).systemAlertsSettings;
/**
 * Alerts that are generated before time threshold are obsolete
 */ export const alertsTimeThreshold = (state)=>mainSelector(state).alertsTimeThreshold;
/**
 * Dismissed alerts by alert name
 */ export const dismissedAlerts = (state)=>mainSelector(state).dismissedAlerts;
/**
 * @deprecated Use useFormValues hook
 */ export const formSelector = (formName)=>(state)=>get(mainSelector(state).forms, formName, null);
/**
 * Select dropdown state
 */ export const dropdown = (state)=>mainSelector(state).openDropdownId;
/**
 * Print mode
 */ export const printMode = (state)=>mainSelector(state).printMode;
/**
 * Current route data
 */ export const route = (state)=>mainSelector(state).route;
/**
 * Select modal state
 */ export const modal = (state)=>mainSelector(state).openModalId;
/**
 * Select floating modal state
 */ export const floatingModalSelector = (floatingModalId)=>createSelector((state)=>mainSelector(state).openFloatingModals, (openFloatingModals)=>find(openFloatingModals, {
            floatingModalId
        }, null));
/**
 * Select active floating modal
 */ export const activeFloatingModalId = (state)=>mainSelector(state).activeFloatingModalId;
/**
 * Feature toggles
 */ export const featureToggles = (state)=>mainSelector(state).featureToggles;
export const isSignalRConnected = (state)=>mainSelector(state).isSignalRConnected;
/**
 * Websocket state
 */ export const websocketState = (state)=>mainSelector(state).wsState;
export const isReportsInitialized = (state)=>mainSelector(state).isReportsInitialized;
/**
 * displayMode state
 */ export const displayMode = (state)=>mainSelector(state).displayMode;
export const isMobileDisplayMode = (state)=>displayMode(state) === 'mobile';
export const isNewCDAReportsVisible = (state)=>mainSelector(state).isNewCDAReportsVisible;
/**
 * App loading progress state
 * To be implemented
 */ export const appLoadingProgress = ()=>0;
